module.exports = __webpack_public_path__ + "img/receipt.714c1b71.svg";